"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
export default function CareByLifeStage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="87591" id="choose-your-treatment-path" className="bg-background pt-4 pb-12 md:pt-8 md:pb-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-8 md:mb-12 text-center">
          <h2 className="text-2xl sm:text-4xl font-bold tracking-tight text-primary font-default">Which describes you?</h2>
        </div>
        <div ref={ref} className={`grid grid-cols-1 gap-6 md:gap-8 md:grid-cols-2 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Card className="bg-[#264256] text-white border-2 border-[#a9e5c9] shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 flex flex-col">
            <CardHeader className="p-6 md:p-8 pb-2">
              <CardTitle className="text-xl md:text-2xl font-bold font-default text-white">I need spine surgery</CardTitle>
            </CardHeader>
            <CardContent className="px-6 md:px-8 pb-6 md:pb-8 pt-0 flex-grow">
              <p className="text-base md:text-lg opacity-90 font-default leading-relaxed text-white">
                You have been told you need surgery, or conservative treatment has not helped. We offer microdiscectomy, nucleoplasty and vertebroplasty. HSE reimburses up to €8,558, which for most patients covers the surgery in full. Travel, accommodation and rehabilitation are paid separately.
              </p>
            </CardContent>
            <CardFooter className="p-6 md:p-8 pt-0">
              <Button asChild className="rounded-full bg-[#65d19d] text-[#264256] hover:bg-[#65d19d]/90 font-semibold px-6 md:px-8 py-3 md:py-4 h-auto text-base transition-colors">
                <Link to="/spine-surgery">See options</Link>
              </Button>
            </CardFooter>
          </Card>
          <Card className="bg-[#264256] text-white border-2 border-[#a9e5c9] shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 flex flex-col">
            <CardHeader className="p-6 md:p-8 pb-2">
              <CardTitle className="text-xl md:text-2xl font-bold font-default text-white">I need pain management</CardTitle>
            </CardHeader>
            <CardContent className="px-6 md:px-8 pb-6 md:pb-8 pt-0 flex-grow">
              <p className="text-base md:text-lg opacity-90 font-default leading-relaxed text-white">You are living with chronic back, shoulder, hip or knee pain and want treatment without surgery. We offer nerve blocks, PRP therapy, epidural injections and cryodenervation. HSE reimburses up to €874 per procedure.</p>
            </CardContent>
            <CardFooter className="p-6 md:p-8 pt-0">
              <Button asChild className="rounded-full bg-[#65d19d] text-[#264256] hover:bg-[#65d19d]/90 font-semibold px-6 md:px-8 py-3 md:py-4 h-auto text-base transition-colors">
                <Link to="/pain-management">See options</Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}